import { animate, animation, style } from '@angular/animations';

export const outgoingAnimation = animation([
  style({
    opacity: 1,
  }),
  animate('1000ms ease', style({ opacity: 0 })),
]);
